import React from "react";

export default function ExportSupplier() {
  return (
    <>
      <div className="comp-heading">
        <div className="row">
          <div className="col-lg-4">
            <label>Export Supplier</label>
          </div>
        </div>
      </div>
      <br />
    </>
  );
}
